module.exports = __webpack_public_path__ + "static/media/nimes_tempel_tn.2d614f45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_tempel_tn.jpg
// module id = 738
// module chunks = 0